import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, FormArray, Validators, AbstractControl} from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { ClienteService } from 'src/app/services/cliente.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { FacturacionService } from 'src/app/services/facturacion.service';
import { UsuariosService } from './../../services/usuarios.service';
import {MatSelectModule} from '@angular/material/select';

import { EmailService } from 'src/app/services/email.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';

import { OPCIONES_MOTIVO_ALTA, IVA, PRECIO_UNITARIO_AMPLIADA, PRECIO_UNITARIO_AMPLIADA_IVA } from './../../constants/constants';
import { ValidacionesService } from 'src/app/services/validaciones.service';

@Component({
  selector: 'app-xtensa-ampliada',
  templateUrl: './xtensa-ampliada.component.html',
  styleUrls: ['./xtensa-ampliada.component.scss']
})
export class XtensaAmpliadaComponent implements OnInit {

  isLinear = false;
  datosCliente: any={};
  datosContacto: any={};
  importe: any={};
  motivosAlta?: String[];
  public empresasInvitadas?:  any={};
  public invitaciones: any;
  mailContratistas: any={};
  public mails: any[] = [];
  public IDcontratistas: any[] = [];
  public contratistas: any[] = [];
  public IDcliente: any;
  public cliente: any
  contratista:any
  flag: boolean
  nombreComercial:any
  errorCif:any

  templateCliente:any
  templateContratista:any

  newsletter:any

  iva: number
  precioAmpliada: number
  precioAmpliadaIva: number

   get contactoMail(): FormArray{
    return <FormArray>this.datosContacto.get('contactoMail')
  }

  constructor(private formBuilder: FormBuilder, private apollo: Apollo, 
    private clienteService: ClienteService, private emailService: EmailService,
    private contratistaService: ContratistaService, private usuarioService: UsuariosService,
    public confirmacionService: ConfirmacionService, private facturaService:FacturacionService, private validacionService:ValidacionesService) {
      this.flag = false
      this.motivosAlta = OPCIONES_MOTIVO_ALTA
      this.iva = IVA;
      this.precioAmpliada = PRECIO_UNITARIO_AMPLIADA;
      this.precioAmpliadaIva = PRECIO_UNITARIO_AMPLIADA_IVA;
      this.buildForm();
  }

  ngOnInit() {

  }

  private buildForm(){
    this.datosCliente = this.formBuilder.group({
      nombreComercial: ['', [Validators.required]],
      cif: ['', [Validators.required, this.validCif()]],
      motivo: [''],
      nombre: ['', [Validators.required]],
      mail: ['', [Validators.required,Validators.email]],
      empresasInvitadas: ['', [Validators.required, Validators.min(1), Validators.max(15)]],
      residuosPeligrosos: [true, [Validators.required]],
    });
    this.datosContacto = this.formBuilder.group({
      contactoMail: this.formBuilder.array([this.buildInvitacion()])
    });
    this.importe = this.formBuilder.group({
      policy: ['', [Validators.required]],
    });

    /* this.datosGestor.valueChanges
    .subscribe(value => {
      console.log(value);
    }); */

    }

/* numSequence(n: number): Array<number> { 
    return Array(n); 
  }  */

  addInvitacion(number: number){
    let invitacionesCounter = 0;
    if(number === 1) return
    do{
      this.contactoMail.push(this.buildInvitacion());
      invitacionesCounter++;
    } while (invitacionesCounter < number-1)
    console.log(this.datosContacto.value)
  }

  buildInvitacion(){
    return  this.formBuilder.group({
      mail: ['', [Validators.required, Validators.email]],
      cif: ['', [Validators.required, this.validCif()]]
    });
  }

 setInvitaciones() {
    this.empresasInvitadas = this.datosCliente.value.empresasInvitadas ? parseInt(this.datosCliente.value.empresasInvitadas) : 1;

    this.addInvitacion(this.empresasInvitadas)
  }
save(event:Event){
    event.preventDefault();
    const value = this.datosCliente.value;
   /*  console.log(value); */
    this.flag = true
    this.addCliente()
  }

  setNewsletter(e:any){
    if(e.target.checked) this.newsletter = e.target.checked
  }

  resetEmpresasInvitadas(){
    this.contactoMail.clear()
    this.contactoMail.push(this.buildInvitacion())
    
    
  }

  checkCliente(e:any) {
    if (e.target) {

      this.getClientesCif()
      
    }
  }

  validCif(){
    return (control: AbstractControl):{[key: string]: boolean} | null=>{
    
   let cif:any = control.value

      if(this.validacionService.checkCif(cif) == false){
      
        return {'validCif':true}
      }
    return null;
    
  }
}

  checkUser(e:any){
    console.log(e.target.value);
    
      this.apollo.watchQuery<any>({
        query: this.usuarioService.getAllUsuarios(),
      })
        .valueChanges
        .subscribe(({data, loading, errors}) => {
          const userExist = data.users.filter((user:any)=>e.target.value == user.email)
        if (userExist.length > 0) {
          this.confirmacionService.openPopUpCreateUser(
            'Error al crear un nuevo cliente',
            `Ya hay un usuario registrado con ese Email, por favor pruebe con otro email o si lo desea puede iniciar sesión.`) 
        }
        
        })
    }

 getClientesCif(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClientesCif(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        data.clientes.forEach((element:any) => {

          if (element.cif === this.datosCliente.value.cif) {
            /* console.log(element); */
            this.confirmacionService.openPopUpCreateUser(
              'Error al crear un nuevo cliente',
              `Ya hay un cliente registrado con ese CIF, por favor pruebe con otro CIF o si lo desea puede iniciar sesión.`) 
          } 
        });
        
      })
  }


 addCliente(){
    this.apollo.mutate<any>({
      mutation: this.clienteService.addCliente(),
      variables: {
        "input": {
          "data": {
            "nombreComercial": this.datosCliente.value.nombreComercial,
            "motivoAlta": this.datosCliente.value.motivo,
            "cif":this.datosCliente.value.cif,
            "firstTime": false,
            "contactoResponsable": {
              "mail": this.datosCliente.value.mail,
              "nombre": this.datosCliente.value.nombre,
            },
            "contratistasInvitados": parseInt(this.datosCliente.value.empresasInvitadas),
            "resPeligrosos": this.datosCliente.value.residuosPeligrosos,
            "contactoContratista": this.datosContacto.value.contactoMail,
            "newsLetter": this.newsletter
          }
        }
      }
    }).subscribe(({data, errors}) => {
        if(data){
        console.log('OK', data)
        console.log(data.createCliente.cliente.id)
        this.IDcliente = data.createCliente.cliente.id
        this.nombreComercial = data.createCliente.cliente.nombreComercial
        /* console.log(this.IDcliente) */
        this.addMail()
        this.addUsuario()

      }
      if(errors){
        console.log('ERROR', errors)
      }
      }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }


  addMail(){
    console.log(this.datosContacto.value.contactoMail)
    this.mails = this.datosContacto.value.contactoMail
    for (let i = 0; i < this.datosContacto.value.contactoMail.length; i++) {
      this.getContratistasCif(this.mails[i])
    }
  
  }

  getContratistasCif(element: any){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistasCif()
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        const contratistasArray = data.contratistas.filter((contratista:any)=>          
          contratista.cif == element.cif)
          if (contratistasArray.length > 0) {
           this.templateContratista = `
                <!DOCTYPE html>
                <html>
                <head>
                <title></title>
                </head>

                <body>
                <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/ampliacion_d5bfa07702.png' style="width:500px; height:340px; display:block;
                margin:auto;">
                <div style="width:500px; margin:auto">
                <p>Estimado ${contratistasArray[0].contactoResponsable.mail}</p>
                <p>Su cliente ${this.nombreComercial} le solicita el registro en Xtensa de nuevos centros Productores.</p>
                <p>Por favor a continuación, inicie sesión para el pago de las correspondientes licencias. </p>
                <a href="www.xtensa.es"><img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/AV_96b6ea682a.png' style="width:100px; height:63px; display:block;
                margin:auto;"></a>
                </div>
                <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
                margin:70px auto;">
                </body>
                </html>`;

                  this.emailService.send(
                    contratistasArray[0].contactoResponsable.mail,
                    'Invitación Xtensa',
                    this.templateContratista
                  );
            this.IDcontratistas.push(contratistasArray[0].id)
            this.getClienteById()
            this.addFacturaAmpliada(this.IDcliente, contratistasArray[0].id)

         } else {
           this.addContratista(element.cif, element.mail);
         } 
                
        
      })
  }

   addContratista(cif:any, mail:any){
  /*   console.log(this.datosContacto.value)
    console.log(this.datosContacto.value.contactoMail) */
    this.apollo.mutate<any>({
      mutation: this.contratistaService.addContratista(),
      variables: {
        "input": {
          "data": {
            "cif": cif,
            "firstTime": false,
            "xtensaBasica": false,
            "contactoResponsable": {
              "mail": mail,
            },
            "clientes": this.IDcliente
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
      console.log(data.createContratista.contratista.id)
      this.contratista= data.createContratista.contratista
      this.IDcontratistas.push(data.createContratista.contratista.id)
      console.log(this.IDcontratistas)
      this.updateClienteById(this.IDcontratistas)
      this.addUsuarioContratista(data.createContratista.contratista.contactoResponsable.mail)
      this.addFacturaAmpliada(this.IDcliente, this.contratista.id)
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

    getClienteById(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.IDcliente
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.cliente = data.cliente
       console.log(this.cliente.contratistas) 
        this.cliente.contratistas.forEach((elementC:any) => {

          this.IDcontratistas.push(elementC.id)
          
        });

        this.updateClienteById(this.IDcontratistas)

      })
  }

  

   updateClienteById(id: any){

    console.log(this.IDcliente)
    console.log(this.IDcontratistas)
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": this.IDcliente,
          },
          "data": {
            "contratistas": id,
            
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO CORRECTOOOOO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  addUsuario(){
    let password = this.generatePassword()
    this.apollo.mutate<any>({
      mutation: this.usuarioService.addUser(),
      variables: {
        "input": {
          "data": {
              "name":  this.datosCliente.value.nombre,
              "email": this.datosCliente.value.mail,
              "username": this.datosCliente.value.mail,
              "password": password,
              "rol": 'admin',
              "cliente": this.IDcliente,
              "confirmed": true
            }
          }
        }
    }).subscribe(({data, errors}) => {
      
      if(data){
        this.templateCliente = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/bienvenidaxtensa_df33d6a1cd.png' style="width:500px; height:340px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        <h3 style="text-align:center">¡COMIENCE A DISFRUTAR DE LAS VENTAJAS DE XTENSA!</h3>
        <div style="text-align: center">
        <div style="display:flex">
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/balance_bcd5162eca.png' style="width:100px; height: 67px; margin: 1rem 0.5rem 0 0">
        <h3 style="color:#1f775a; margin-top:2rem">ASEGURE EL CONTROL DEL CUMPLIMIENTO LEGAL Y LA GESTIÓN DE SUS RESIDUOS</h3>
        </div>
        <div style="display:flex">
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/planet_earth_7fb3c92864.png' style="width:70px; height: 67px; margin: 3rem 2rem 0 0">
        <h3 style="color:#1f775a; margin-top:4.2rem">REFUERCE SU COMPROMISO MEDIOAMBIENTAL</h3>
        </div>
        <div style="display:flex">
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/warning_46ffab2f20.png' style="width:70px; height: 67px; margin: 3rem 2rem 0 0">
        <h3 style="color:#1f775a; margin-top: 4.2rem">DIGITALICE LA GESTIÓN DE RESIDUOS</h3>
        </div>
        <div style="text-align:center">
        <p>Sus credenciales son:</p>
        <p>Usuario: ${this.datosCliente.value.mail}</p>
        <p>Contraseña: ${password}</p>
        </div>
        </div>
        </div>
        
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
        margin:70px auto;">
        </body>

        </html>`;
        console.log(this.datosCliente.value.mail)
       
        this.emailService.send(this.datosCliente.value.mail,'Alta nuevo cliente Xtensa', this.templateCliente)

        console.log('OK', data)
        console.log(data)
    

      }
      if(errors){
        console.log('ERROR', errors)
      }
      
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  addUsuarioContratista(mail:any){
    let password = this.generatePassword()
    this.apollo.mutate<any>({
      mutation: this.usuarioService.addUser(),
      variables: {
        "input": {
          "data": {
              "email": mail,
              "username": mail,
              "password": password,
              "rol": 'admin',
              "contratista": this.contratista.id,
              "confirmed": true
            }
          }
        }
    }).subscribe(({data, errors}) => {

      this.templateContratista = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/logo_xtensa_4908df85aa.png' style="width:200px; height:126px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        <h1 style="color: #1F775A; font-weight:bolder; text-align:center">Ha recibido una invitación de ${this.nombreComercial}</h1>
        
        <p>Estimado ${mail}</p>
        <p>Su cliente le invita a utilizar XTENSA con el objetivo de verificar que realiza una correcta gestión de los residuos.</p>
        <p>Usted tiene cedida la imagen de su cliente en sus instalaciones, el cual quiere estar seguro de que en dichos centros se realiza una correcta gestión de los residuos, por lo que le va a solicitar, a través de XTENSA, la documentación que lo justifica (alta de centro productor, autorizaciones de gestores, contratos de tratamiento, memoria anual, etc.).</p>
        <p>A continuación, deberá  acceder al Área Virtual, rellenar los datos
        básicos y realizar el pago de la licencia. Una vez confirmado el
        pago, podrá disfrutar del uso de  XTENSA accediendo al
        Área Virtual con las mismas claves que aparecen en este correo.</p>
        <a href="www.xtensa.es"><img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/AV_96b6ea682a.png' style="width:100px; height:63px; display:block;
        margin:auto;"></a>
        <p>Su usuario es: ${mail}</p>
        <p>Su contraseña es: ${password}</p>
        </div>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
        margin:70px auto;">
        </body>
        </html>`;
    
        this.emailService.send(mail, 'Invitación Xtensa Ampliada', this.templateContratista) 
    
      
        console.log('OK', data)
       
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  generatePassword() {
    let length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
}

addFacturaAmpliada(idCliente: any, idContratista: any) {  
    this.apollo
      .mutate({
        mutation: this.facturaService.addFactura(),
        variables: {
          input: {
            data: {
              cliente: idCliente,
              contratista: idContratista,
              concepto: "LICENCIA XTENSA ANUAL AMPLIADA",
              estado: "invitacion",
              precioUnitario: this.precioAmpliada,
              iva: this.iva,
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
            console.log('OK', data);
        },
        (error) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }


}
